import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { DuplicateCandidate } from '../../training-plans/training-plans.types';

/** Eine offene Dubletten-Review (Auto-Sync): die neu importierte Aktivität + die
 *  bestehenden Treffer mit gleichem Fingerprint. */
export interface FitDuplicateReview {
  file_id: string;
  filename: string | null;
  source: string | null;
  session_id: number | null;
  date: string | null;
  fingerprint: string | null;
  candidates: DuplicateCandidate[];
}

@Injectable({ providedIn: 'root' })
export class FitDuplicateReviewService {
  private readonly http = inject(HttpClient);
  private readonly base = '/api/training_analysis/fit-duplicate-reviews';

  list(): Observable<FitDuplicateReview[]> {
    return this.http
      .get<{ data: FitDuplicateReview[] }>(`${this.base}/`)
      .pipe(map((r) => r?.data ?? []));
  }

  /** keep = Markierung entfernen (behalten); discard = Session inkl. FIT-Datei löschen. */
  resolve(fileId: string, action: 'keep' | 'discard'): Observable<unknown> {
    return this.http.post(`${this.base}/${encodeURIComponent(fileId)}/resolve/`, { action });
  }

  /** Admin-only: Gesamtzahl offener FIT-Dubletten-Reviews über ALLE User. */
  adminPendingCount(): Observable<number> {
    return this.http
      .get<{ data: { total: number } | null }>(`${this.base}/admin/pending-count/`)
      .pipe(map((r) => r?.data?.total ?? 0));
  }
}
